var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.031 12.938c.313-.313.281-.782 0-1.094L5.25 8.25h9A.74.74 0 0 0 15 7.5v-1a.76.76 0 0 0-.75-.75h-9l3.781-3.563c.281-.312.313-.78 0-1.093L8.344.406a.774.774 0 0 0-1.063 0L1.22 6.5a.684.684 0 0 0 0 1.031l6.062 6.094c.282.281.75.281 1.063 0l.687-.688Z",
    fill: "#11C5F7"
  })));
};
export default SvgArrowLeft;